import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

const VerifyOTP = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); 
    if (value) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index < 5) inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleVerify = async () => {
    if (otp.join("").length === 6) {
      try {
        const response = await apiService.postData("admin/validate-otp", {
          email: location.state.email,
          otp: otp.join(""),
        });

        const { error, code, message } = response;

        if (!error && code === 200) {
          toast.success(message || "OTP Verified Successfully!");
          navigate("/reset-password", {
            state: {
              email: location.state.email,
              otp: otp.join(""),
            },
          });
        } else {
          toast.error(message || "Invalid OTP. Please try again.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again later.");
      }
    } else {
      toast.warn("Please enter the complete 6-digit OTP.");
    }
  };

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center vh-100">
    <ToastContainer />
  
    <div className="text-center mb-3">
      <img src="/assets/img/logo.png" alt="logo" width="250" />
    </div>
  
    <div className="card p-4 card-primary shadow" style={{ width: "400px", borderRadius: "10px" }}>
        <h6>Verify OTP</h6>
      <div className="text-center mb-3">
        <p className="text-muted">Enter the 6-digit OTP sent to your email.</p>
      </div>
  
      <div className="d-flex justify-content-between">
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            maxLength={1}
            value={data}
            ref={(el) => (inputRefs.current[index] = el)}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            className="form-control text-center fs-4 fw-bold"
            style={{ width: "50px", height: "50px", margin: "0 5px" }}
          />
        ))}
      </div>
  
      <button
        className="btn btn-primary btn-lg w-100 mt-4"
        onClick={handleVerify}
        disabled={otp.join("").length !== 6}
      >
        Verify OTP
      </button>
    </div>
  </div>
  
  );
};

export default VerifyOTP;
